import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------credit api's-------------------------------->
    /**
     * get tax index page
     * @param {} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getReportingTags(sort, label, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/reportingtag/index' + '?sort=' + sort + '&label=' + label)
    },
    postreporttag(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/reportingtag/create', data)
    },
    postupdatereporttag(id, data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/reportingtag/update/' + id, data)
    },
    getreporttag(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/reportingtag/view/' + id)
    },
    tagstatuschange(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/reportingtag/statuschange/', data)
    },
    deletetag(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/reportingtag/singledelete/', data)
    },
    tagoptionremove(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/reportingtag/optionvalidation/', data)
    },

}